import truthy from '../../helpers/truthy';

truthy.op = '!!';

export default truthy;
